import { apiPatch, apiPost } from '@forwardflow/services/Axios/configs'
import { BusinessDetails, ResponseSuccess } from '@forwardflow/types'

// Submit business details
export default class BusinessService {
   static formatBusinessDetails(businessDetails: BusinessDetails) {
      let socialMediaUrls = businessDetails.socialMediaProfileUrls
      if (typeof socialMediaUrls === 'string') {
         // eslint-disable-next-line @typescript-eslint/ban-ts-comment
         // @ts-ignore
         socialMediaUrls = socialMediaUrls.includes(',')
            ? socialMediaUrls?.split(',')
            : socialMediaUrls?.includes(' ')
            ? socialMediaUrls?.split(' ')
            : [socialMediaUrls]
      }
      return {
         brandType: businessDetails.brandType || 'Low-Volume Standard',
         brandName: businessDetails.brandName,
         authorizedRepresentativeFirstName:
            businessDetails.authorizedRepresentativeFirstName,
         authorizedRepresentativeLastName:
            businessDetails.authorizedRepresentativeLastName,
         phoneNumber: businessDetails.phoneNumber,
         legalBusinessName: businessDetails.legalBusinessName,
         friendlyBusinessName: businessDetails.friendlyBusinessName,
         email: businessDetails.email,
         customerName: businessDetails.customerName,
         street: businessDetails.street,
         streetSecondary: businessDetails.streetSecondary,
         city: businessDetails.city,
         region: businessDetails.region,
         postalCode: businessDetails.postalCode,
         isoCountry: businessDetails.isoCountry || 'US',
         businessType:
            businessDetails.businessType || 'Limited Liability Corporation',
         businessIndustry: businessDetails.businessIndustry || 'REAL_ESTATE',
         businessRegistrationIdentifier:
            businessDetails.businessRegistrationIdentifier || 'EIN',
         authorizedRepresentativePhoneNumber:
            businessDetails.authorizedRepresentativePhoneNumber,
         authorizedRepresentativeEmail:
            businessDetails.authorizedRepresentativeEmail,
         vertical: businessDetails.vertical,
         businessRegistrationNumber: businessDetails.businessRegistrationNumber,
         websiteUrl: businessDetails.websiteUrl,
         businessIdentity:
            businessDetails.businessIdentity || 'isv_reseller_or_partner',
         businessRegionsOfOperation:
            businessDetails.businessRegionsOfOperation || 'USA_AND_CANADA',
         authorizedRepresentativeJobPosition:
            businessDetails.authorizedRepresentativeJobPosition,
         authorizedRepresentativeBusinessTitle:
            businessDetails.authorizedRepresentativeBusinessTitle
               ? businessDetails.authorizedRepresentativeBusinessTitle
               : businessDetails.authorizedRepresentativeJobPosition,
         stockExchange: businessDetails.stockExchange,
         stockTicker: businessDetails.stockTicker,
         companyType: businessDetails.companyType,
         socialMediaProfileUrls: socialMediaUrls,
      }
   }

   static submitBusinessDetails = async (businessDetails: BusinessDetails) => {
      const data = await apiPost<ResponseSuccess<BusinessDetails>>({
         apiPath: `/business-informations`,
         data: this.formatBusinessDetails(businessDetails),
      })
      return data.data
   }

   // update business details

   static updateBusinessDetails = async (businessDetails: BusinessDetails) => {
      const data = await apiPatch<ResponseSuccess<BusinessDetails>>({
         apiPath: `/organization-account/business-details`,
         data: this.formatBusinessDetails(businessDetails),
      })
      return data.data
   }
}
